<template lang="pug">
  SspLayout.user-edit(area="core")
    template(slot="actions")
      button.btn.btn-default(v-if="!welcome && userId" type="button" @click="togglePasswordEdit") {{ passwordEdit ? 'Close Edit' : 'Edit'}} Password

    .row
      .col-md-12
        SspSaveForm(@onSubmit="save" :saveDisabled="!isValid" :saving="saving")
          .form-horizontal
            .form-group
              label.col-sm-2.control-label Username
              .col-sm-8
                input.form-control(type="text" placeholder="Name" v-model="username")

            .form-group
              label.col-sm-2.control-label Email
              .col-sm-8
                input.form-control(type="email" placeholder="Email" v-model="email")

            .form-group
              label.col-sm-2.control-label Default Group
              .col-sm-8
                GroupSelect(v-model="defaultGroupId")


            .form-group(v-visible-for="['ROLE_ORGANIZATION_ADMIN']")
              label.col-sm-2.control-label Additional Groups
              .col-sm-8
                GroupsMultipleSelect(v-model="additionalGroups")

            .form-group
              label.col-sm-2.control-label Enabled
              .col-sm-1
                input.mt10(type="checkbox" v-model="enabled")

              span(v-if="userId")
                label.col-sm-1.control-label Locked
                .col-sm-1
                  i.fa.pt10(:class="locked ? 'fa-lock' : 'fa-unlock'")

            span(v-if="userId")
              .form-group
                label.col-sm-2.control-label Phone Numbers
                .col-sm-8
                  input.form-control(type="text" @keyup.32="addPhoneNumber(phonenumberInput)" v-model="phonenumberInput" placeholder="Space Separated Phone Numbers")
              .form-group(v-if="phonenumbers.length > 0")
                .col-sm-2
                .col-sm-8
                  PillsList(:items="phoneNumberPills" :removable="true" @removeClick="removePhonenumber")

            .form-group
              label.col-sm-2.control-label Password Expires
              .col-sm-8
                select.form-control(v-model="passwordExpiryDays")
                  option(:value="0") Never
                  option(:value="90") in 90 days
                  option(:value="180") in 180 days
                  option(:value="365") in one year

            .form-group(v-if="!userId")
              label.col-sm-2.control-label Send welcome e-mail
              .col-sm-8
                .checkbox
                  label
                    input.welcome(type="checkbox" v-model="welcome" :checked="welcome")

            .password-edit(v-if="passwordEdit === true")
              .form-group
                label.col-sm-2.control-label Password
                .col-sm-8
                  input.form-control(type="password" placeholder="New Password" v-model="password")

              .form-group
                label.col-sm-2.control-label Password
                .col-sm-8
                  input.form-control(type="password" placeholder="Retype Password" v-model="repeatPassword")
</template>


<script>
import miniToastr from 'mini-toastr'
import Security from '@/service/apis/Security'
import PillsList from '@/components/common/PillsList'
import GroupSelect from '@/components/ssp/GroupSelect'
import GroupsMultipleSelect from '@/components/ssp/GroupsMultipleSelect'
import Util from '@/service/Util'

export default {
  data: () => ({
    saving: false,
    username: null,
    email: null,
    enabled: true,
    passwordExpiryDays: 0,
    locked: false,
    defaultGroupId: null,
    password: null,
    userGroups: null,
    repeatPassword: null,
    passwordEdit: false,
    phonenumberInput: null,
    phonenumbers: [],
    welcome: true,
    errorMsg: null,
    additionalGroups: []
  }),
  created() {
    if (this.userId) {
      this.welcome = false
      Security.getUser(this.userId)
        .then((resp) => {
          this.username = resp.data.user.username
          this.email = resp.data.user.email
          this.enabled = resp.data.user.enabled
          this.passwordExpiryDays = resp.data.user.passwordExpiry.passwordExpiryDays
          this.locked = resp.data.user.locked
          this.defaultGroupId = resp.data.user.defaultGroup.id
          if (resp.data.user.phoneNumbers) {
            this.phonenumbers = resp.data.user.phoneNumbers.phoneNumber
          }
        })
    }
  },
  methods: {
    save() {
      this.saving = true
      const req = this.createPayload()
      const call = !this.userId ? Security.createUser({ user: req, sendWelcomeMessage: this.welcome }) : Security.updateUser(this.userId, { user: req })
      const action = !this.userId ? 'created' : 'updated'
      call
        .then((resp) => resp.data.userId)
        .then((userId) => {
          const canAddMoreGroups = userId && this.additionalGroups.length > 0
          const promiseArray = canAddMoreGroups ? this.additionalGroups.map((groupId) => Security.addUserToGroup(groupId, userId, { groupId, userId })) : []
          return Promise.all(promiseArray)
        })
        .then(() => {
          miniToastr.success(`User successfully ${action}`)
          this.$router.push(!this.userId ? { name: 'users' } : { name: 'user', params: { id: this.userId } })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    },
    createPayload() {
      const req = {
        username: this.username,
        defaultGroupId: this.defaultGroupId,
        email: this.email,
        enabled: this.enabled,
        passwordExpiryDays: this.passwordExpiryDays,
        phoneNumbers: {
          phoneNumber: null
        }
      }
      if (this.userId) {
        req.id = this.userId
      }
      if (this.welcome) {
        req.plainPassword = Util.randomText(20)
      }
      if (this.phonenumbers.length > 0) {
        req.phoneNumbers.phoneNumber = this.phonenumbers
      }
      if (this.passwordEdit) {
        req.plainPassword = this.password
      }

      return req
    },
    removePhonenumber(index) {
      this.phonenumbers.splice(index, 1)
    },
    addPhoneNumber(value) {
      const chunks = value.match(/([\d+]+\s+)/g)
      if (chunks === null) { return }

      const trimmed = chunks.map((t) => t.trim())
      this.phonenumbers.push(trimmed.toString())
      this.phonenumberInput = null
    },
    togglePasswordEdit() {
      this.password = null
      this.repeatPassword = null
      this.passwordEdit = !this.passwordEdit
    }
  },
  watch: {
    welcome() {
      if (!this.welcome && !this.userId) {
        this.passwordEdit = true
      } else {
        this.passwordEdit = false
      }
    }
  },
  computed: {
    phoneNumberPills() {
      return this.phonenumbers.map((p) => ({ name: p }))
    },
    isValid() {
      return this.validPassword && this.username && this.email && this.defaultGroupId
    },
    validPassword() {
      if (this.password || this.repeatPassword) {
        return this.password === this.repeatPassword
      }
      return true
    },
    userId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    PillsList,
    GroupSelect,
    GroupsMultipleSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/management/user/UserEdit.vue